import { Marker, useMap, useMapEvents } from 'react-leaflet';
import { useCallback, useEffect, useState, useMemo, useRef, use } from 'react';
import { Rectangle, FeatureGroup } from 'react-leaflet';
import L, { DomEvent } from 'leaflet';
import 'leaflet-geometryutil';
import html2canvas from "html2canvas";
import { createPortal } from 'react-dom';
import '../../styles/PrintControl.css'
import jsPDF from 'jspdf';
import { useDispatch, useSelector } from 'react-redux';
import { setPrinting } from '../../store/reducers/helpersReducer.js';
import drawLocales from 'leaflet-draw-locales'
import { setStop } from '../../store/reducers/stateReducer.js';
import writeXlsxFile from 'write-excel-file';
import '../../icons/Roboto-Light-bold.js';
import '../../icons/Roboto-Light-normal.js';
import '../../icons/Roboto-Medium-normal.js'
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, FormLabel, Radio, RadioGroup } from '@mui/material';
import { Tooltip } from '@mui/material';
import { Paper } from '@mui/material';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Switch } from '@mui/material';
import { Button } from '@mui/material';
import { IconButton } from '@mui/material';
import { FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { selectAccountingsGroupedByKtpNew, selectChecklistFilter, selectElectricityFiltered, selectRulesMap, selectTransformers } from '../../store/selectors/supervisionSelector.js';
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import proj4 from "proj4";

proj4.defs('MSK05',
    '+proj=tmerc +lat_0=0 +lon_0=46.8916666667 +k=1 +x_0=300000 +y_0=-4542821.516 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.219999999995224 +units=m +no_defs +type=crs'
);
// proj4.defs('MSK05', '+proj=tmerc +lat_0=0 +lon_0=46.8916666667 +k=1 +x_0=300000 +y_0=-4542821.516 +ellps=krass +units=m +no_defs');


function convertWGS84ToMSK05(longitude, latitude) {
    try {
        const [x, y] = proj4('WGS84', 'MSK05', [latitude, longitude]);
        // return {
        //     longitude: Number(longitude.toFixed(6)),
        //     latitude: Number(latitude.toFixed(6)),
        //     // z: Number(z.toFixed(3)) 
        // };
        return [Number(x.toFixed(10)), Number(y.toFixed(10))]
    } catch (error) {
        console.error('Ошибка преобразования:', error);
        return null;
    }
}


// Automatically defines Leaflet.draw to the specified language
drawLocales('ru')


const MM_TO_METERS = 0.001;
const MM_TO_INCH = 1 / 25.4;

export const getPaperDimensions = (format, orientation) => {
    const formatMatch = format.toLowerCase().match(/(a|b)(\d)/i);
    if (!formatMatch) throw new Error('Invalid paper format');


    const [, series, size] = formatMatch;
    const n = parseInt(size, 10);

    let baseWidth, baseHeight;
    if (series === 'a') {
        baseWidth = 841;   // A0 width in mm
        baseHeight = 1189; // A0 height in mm
    } else {
        baseWidth = 1000;  // B0 width in mm
        baseHeight = 1414; // B0 height in mm
    }

    const divisor = 2 ** (n / 2);
    const width = Math.floor(baseWidth / divisor);
    const height = Math.floor(baseHeight / divisor);
    return orientation === 'landscape'
        ? { width: height, height: width }
        : { width, height };
};


const Electricity = (props) => {
    const data = useSelector(selectElectricityFiltered)
    return data
}

const PrintControl = (props) => {
    const map = useMap();
    const dispatch = useDispatch();
    const [hide, setHide] = useState(false);
    const [hidden, setHidden] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isCalculated, setIsCalculated] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [params, setParams] = useState({
        scale: 1000,
        dpi: 150,
        paperSize: 'A4',
        orientation: 'landscape',
        accounting: false,
        statement: false,
        measure: false
    });
    const [grid, setGrid] = useState({ width: 0, height: 0, tiles: [], zoom: null });
    const [printingParams, setPrintingParams] = useState(null);
    const [bounds, setBounds] = useState(null)

    const { width: paperWidth, height: paperHeight } = useMemo(() =>
        getPaperDimensions(params.paperSize, params.orientation),
        [params.paperSize, params.orientation]);

    const drawCloseRef = useRef(null)
    const isPrintingRef = useRef(isPrinting);
    const settingsRef = useRef(null)
    const [backupStyle, setBackupStyle] = useState(null)
    const backupStyleRef = useRef(backupStyle)
    const [polygon, setPolygon] = useState(null)
    const [isDrawing, setIsDrawing] = useState(false)
    const polygonRef = useRef(null)
    const drawingRef = useRef(new L.Draw.Polygon(map, { shapeOptions: { pane: 'drawingPane' } }))

    const data = useSelector(selectAccountingsGroupedByKtpNew)
    const rulesMap = useSelector(selectRulesMap);
    const checklistFilter = useSelector(selectChecklistFilter);
    const transformers = useSelector(selectTransformers)


    useEffect(() => {
        if (isDrawing) {
            drawingRef.current.enable()
            map.fire('signal:drawing', { source: 'print', state: true })
        } else {
            drawingRef.current.disable()
        }
    }, [isDrawing])


    useMapEvents({
        'draw:created': (e) => {
            if (isDrawing) {
                polygonRef.current = e.layer;
                map.addLayer(polygonRef.current)
                polygonRef.current.editing.enable()
                setPolygon(polygonRef.current)
                setBounds(polygonRef.current.getBounds())
            }
        },
        'draw:editvertex': (e) => {
            if (!polygonRef.current || !isDrawing) return
            setBounds(new L.LatLngBounds(polygonRef.current.getLatLngs()))
            setPolygon(new L.Polygon(polygonRef.current.getLatLngs()))
        },

        'signal:drawing': (e) => {
            console.log(e)
            if (e.source !== 'print') {
                setHide(e.state)
            }
        }


    })
    useEffect(() => {
        if (drawCloseRef.current) {
            // Блокируем все события Leaflet
            DomEvent.disableClickPropagation(drawCloseRef.current);
            DomEvent.disableScrollPropagation(drawCloseRef.current);

            // Дополнительная блокировка для touch-устройств
            DomEvent.on(drawCloseRef.current, 'touchstart', DomEvent.stopPropagation);
        }
    }, [drawCloseRef.current]);




    const getSafeBounds = useCallback((b) => {
        try {
            if (b instanceof L.LatLngBounds) return b;
            if (Array.isArray(b)) return L.latLngBounds(b);
            if (b?.northEast && b?.southWest) return L.latLngBounds(b.southWest, b.northEast);
            return null;
        } catch {
            return null;
        }
    }, []);

    const metersToPixels = useCallback((meters, center) => {
        const destPoint = L.GeometryUtil.destination(center, 90, meters);
        const point1 = map.latLngToContainerPoint(center);
        const point2 = map.latLngToContainerPoint(destPoint);
        return Math.abs(point2.x - point1.x);
    }, [map]);


    const calculateZoomFromDPI = useCallback(() => {
        const safeBounds = getSafeBounds(bounds);
        if (!safeBounds || !map) return map.getZoom();

        try {
            const center = safeBounds.getCenter();

            // Размер бумаги в дюймах
            const paperWidthInch = paperWidth * MM_TO_INCH;
            const paperHeightInch = paperHeight * MM_TO_INCH;

            // Требуемые пиксели при заданном DPI
            const targetWidthPixels = params.dpi * paperWidthInch;
            const targetHeightPixels = params.dpi * paperHeightInch;

            // Физические размеры, которые нужно отобразить (в метрах)
            const widthMeters = (paperWidth * MM_TO_METERS) * params.scale;
            const heightMeters = (paperHeight * MM_TO_METERS) * params.scale;

            // Вычисляем точку назначения на восток (90°) и на север (0°)
            const eastPoint = L.GeometryUtil.destination(center, 90, widthMeters);
            const northPoint = L.GeometryUtil.destination(center, 0, heightMeters);

            // Координаты точки в базовом масштабе (текущий зум карты)
            const baseZoom = map.getZoom();
            const centerProjected = map.project(center, baseZoom);
            const eastProjected = map.project(eastPoint, baseZoom);
            const northProjected = map.project(northPoint, baseZoom);

            // Расстояние в пикселях при baseZoom
            const baseWidthPx = Math.abs(eastProjected.x - centerProjected.x);
            const baseHeightPx = Math.abs(northProjected.y - centerProjected.y);

            // Цикл по зуму — находим, при каком зуме ширина/высота в пикселях будет близка к нужной
            let bestZoom = baseZoom;
            let bestDiff = Infinity;

            for (let zoom = map.getMinZoom(); zoom <= map.getMaxZoom(); zoom += 0.1) {
                const scale = map.getZoomScale(zoom, baseZoom);
                const scaledWidth = baseWidthPx * scale;
                const scaledHeight = baseHeightPx * scale;

                const diff = Math.abs(scaledWidth - targetWidthPixels) + Math.abs(scaledHeight - targetHeightPixels);
                if (diff < bestDiff) {
                    bestDiff = diff;
                    bestZoom = zoom;
                }
            }
            return bestZoom;

        } catch (error) {
            console.error('Zoom calculation error:', error);
            return map.getZoom();
        }
    }, [bounds, map, paperWidth, paperHeight, params, getSafeBounds]);


    useEffect(() => {
        calculateZoomFromDPI()
    }, [params])



    // Логика расчета
    const calculateGrid = useCallback(() => {

        const safeBounds = getSafeBounds(bounds);
        if (!safeBounds || !map || isPrintingRef.current) return;
        setIsCalculated(false)
        // const dpi = calculateDPI();
        // if (dpi > 1000) {
        //     setIsError({ color: 'red', text: `DPI слишком большой (${dpi.toFixed()})` })
        //     return
        // }
        // if (dpi <= 0) return;

        const zoom = calculateZoomFromDPI();
        if (zoom > 19.9) {
            setIsError({ color: 'red', text: `Достигнут пределе зума (${zoom.toFixed(2)})` })
            return
        }

        try {
            // const mapBounds = map.getBounds();
            // if (!safeBounds.intersects(mapBounds)) {
            //     setGrid({ cols: 0, rows: 0, tiles: [] });
            //     return;
            // }


            // Calculate visible area
            // const visibleNorth = Math.min(safeBounds.getNorth(), mapBounds.getNorth());
            // const visibleSouth = Math.max(safeBounds.getSouth(), mapBounds.getSouth());
            // const visibleEast = Math.min(safeBounds.getEast(), mapBounds.getEast());
            // const visibleWest = Math.max(safeBounds.getWest(), mapBounds.getWest());

            // const visibleBounds = L.latLngBounds(
            //     [visibleSouth, visibleWest],
            //     [visibleNorth, visibleEast]
            // );

            // Calculate page dimensions in pixels
            const pageWidthPx = ((paperWidth - 10) * MM_TO_INCH) * params.dpi;
            const pageHeightPx = ((paperHeight - 52) * MM_TO_INCH) * params.dpi;

            // Convert bounds to container points
            const nePixel = map.project(safeBounds.getNorthEast(), zoom);
            const swPixel = map.project(safeBounds.getSouthWest(), zoom);
            const areaWidth = Math.abs(nePixel.x - swPixel.x);
            const areaHeight = Math.abs(swPixel.y - nePixel.y);



            // Calculate grid dimensions
            const cols = Math.ceil(areaWidth / pageWidthPx);
            const rows = Math.ceil(areaHeight / pageHeightPx);
            if (cols * rows > 300) {
                setIsError({ color: 'red', text: `Слишком большое количество страниц (${rows * cols})` })
                return
            }
            // Generate tiles
            // const mapSize = map.getSize();
            const tiles = [];
            let pages = 0
            for (let row = 0; row < rows; row++) {
                for (let col = 0; col < cols; col++) {

                    const x1 = swPixel.x + col * pageWidthPx;
                    const y1 = nePixel.y + row * pageHeightPx;
                    const x2 = x1 + pageWidthPx;
                    const y2 = y1 + pageHeightPx;
                    // Skip tiles outside container
                    // if (x2 < 0 || y2 < 0 || x1 > mapSize.x || y1 > mapSize.y) continue;


                    // Convert to geographical coordinates
                    const nw = map.unproject([x1, y1], zoom);
                    const se = map.unproject([x2, y2], zoom);
                    // Clamp to map bounds
                    // const clampedBounds = L.latLngBounds(
                    //     [Math.max(nw.lat, safeBounds.getSouth()),
                    //     Math.max(nw.lng, safeBounds.getWest())],
                    //     [Math.min(se.lat, safeBounds.getNorth()),
                    //     Math.min(se.lng, safeBounds.getEast())]
                    // );
                    const clampedBounds = L.latLngBounds(
                        [nw.lat, nw.lng],
                        [se.lat, se.lng]
                    );

                    // TODO: проверить есть ли в рамках прямоугольника какие то данные
                    let intersetcts = false
                    map.eachLayer(layer => {

                        if (layer.options.type) {
                            switch (layer.options.type) {
                                case 'pillar04':
                                case 'pillar10':
                                case 'pillar04-10':
                                case 'transformers':
                                    // console.log(layer.options, layer.options.bounds)
                                    // case 'fider04':
                                    if (layer.options.bounds && clampedBounds.intersects(layer.options.bounds)) intersetcts = true
                                    break;


                                case 'cluster':
                                    layer.getLayers().map(l => {
                                        if (l.options.type && l.options.bounds) {
                                            switch (l.options.type) {
                                                case 'pillar04':
                                                case 'pillar10':
                                                case 'pillar04-10':
                                                case 'transformers':
                                                    // console.log(layer.options.type, l.options.bounds)
                                                    if (l.options.bounds && clampedBounds.intersects(l.options.bounds)) intersetcts = true
                                                    break;
                                            }
                                        }
                                    })
                                    break;
                            }
                        }


                    })
                    if (!intersetcts) continue;
                    tiles.push({
                        // width: (x2 - x1).toFixed(),
                        // height: (y2 - y1).toFixed(),
                        bounds: clampedBounds,
                        center: clampedBounds.getCenter(),
                        pageNumber: pages + 1,
                        // dpi: dpi.toFixed(1)
                        // zoom: zoom.toFixed(2)
                    });
                    pages = pages + 1


                }
            }
            setIsError(null)
            setGrid({ width: pageWidthPx, height: pageHeightPx, tiles, zoom: parseFloat(zoom.toFixed(2)) });
            // setGrid({ cols, rows, tiles, dpi: Number(dpi) });
            setIsCalculated(true)

        } catch (error) {
            console.error('Grid calculation error:', error);
        }
    }, [bounds, map, params, paperWidth, paperHeight]);

    useEffect(() => {
        console.log('bounds', bounds)
        if (!isPrinting) {
            if (bounds) {
                const [west, south, east, north] = bounds.toBBoxString()
                    .split(',')
                    .map(parseFloat);
                //bounds - целевая область, которая будет печататься
                //overview - флаг означающий что подготавливается обзорные фото для предотвращения лишних вычислений
                setPrintingParams({
                    bounds: { west, south, east, north },
                    overview: true,
                    dpi: params.dpi,
                    measure: params.measure,
                    accountingFilter: params.accountingFilter
                })
                setTimeout(() => {
                    calculateGrid()
                }, 1000)

            } else {
                dispatch(setPrinting(null))
            }
        }

    }, [bounds, params])

    useEffect(() => {
        dispatch(setPrinting(printingParams))
    }, [printingParams])

    const hideAllForPrint = () => {
        const toDisable = ['MuiAppBar-root', 'map-controls']
        toDisable.map((cl) => {
            const el = document.getElementsByClassName(cl)[0]
            if (el) el.style.display = 'none'
        })
    }

    const revert = useCallback(() => {
        console.log('revert')
        const app = document.getElementsByClassName('App')[0];
        app.style.width = '100vw'
        app.style.height = '100vh'
        console.log(backupStyleRef.current)
        if (backupStyleRef.current) {
            // app.style.width = backupStyleRef.current.old_app_width
            // app.style.height = backupStyleRef.current.old_app_height
            map.options.zoomDelta = 1
            map.options.zoomSnap = 1
            map.setView(backupStyleRef.current.old_center, backupStyleRef.current.old_zoom, { animate: false });
        }
        const toDisable = ['MuiAppBar-root', 'map-controls']
        toDisable.map((cl) => {
            document.getElementsByClassName(cl)[0].style.display = ''
        })


        map.eachLayer(l => {
            if (l.options.data === 'rexd' || l.options.data === 'rex') map.removeLayer(l)
        })
        setPolygon(null)
        setIsCalculated(false)
        setHidden(true)
        setIsDrawing(false)
        setIsPrinting(false)
        setBackupStyle(null)
        setBounds(null)
        setGrid({ width: 0, height: 0, tiles: [], zoom: null });
        setPrintingParams(null)
        if (polygonRef.current) {
            map.removeLayer(polygonRef.current)
            polygonRef.current = null
        }
        map.fire('signal:drawing', { source: 'print', state: false })
        dispatch(setStop(false))
        map.invalidateSize()
    }, [backupStyleRef.current, map])


    function printMap() {
        map.closePopup()
        dispatch(setStop(true))
        hideAllForPrint()
        map.removeLayer(polygonRef.current)
        polygonRef.current = null
        const a4 = getPaperDimensions('a4', params.orientation)

        // Отключение всех ненужных компонентов
        // const toDisable = ['MuiAppBar-root', 'map-controls', 'leaflet-control-container', 'status-dial-control']
        // toDisable.map((cl) => {
        //     const el = document.getElementsByClassName(cl)[0]
        //     if (el) el.style.display = 'none'

        // })
        //Запиминаем состояние карты
        // const old_center = map.getCenter();
        // const old_zoom = map.getZoom();
        const app = document.getElementsByClassName('App')[0];
        // const old_app_width = app.style.width
        // const old_app_height = app.style.height
        //Удаление нарисовааного прямоугольника
        setBackupStyle({
            old_center: map.getCenter(),
            old_zoom: map.getZoom(),
            old_app_width: app.getBoundingClientRect().width,
            old_app_height: app.getBoundingClientRect().height,
        })
        console.log({
            old_center: map.getCenter(),
            old_zoom: map.getZoom(),
            old_app_width: app.getBoundingClientRect().width,
            old_app_height: app.getBoundingClientRect().height,
        })
        map.eachLayer(l => {
            if (l.options.data === 'rexd') map.removeLayer(l)
        })
        let mainImage = null;
        const overViewImageUrls = []
        const imageUrls = []
        const tableImages = []
        // const legend = []

        let csvString = null
        let csv = [
            ['Номер опоры (тип опоры)', 'Номер опоры (тип опоры)', 'Длина пролета, м']
        ]

        // const revert = () => {
        //     app.style.width = old_app_width
        //     app.style.height = old_app_height
        //     toDisable.map((cl) => {
        //         document.getElementsByClassName(cl)[0].style.display = ''
        //     })

        //     map.options.zoomDelta = 1
        //     map.options.zoomSnap = 1

        //     map.setView(old_center, old_zoom, { animate: false });
        //     map.eachLayer(l => {
        //         if (l.options.data === 'rexd' || l.options.data === 'rex') map.removeLayer(l)
        //     })
        //     setBounds(null)
        //     setHidden(true)
        //     const el = [...document.getElementsByClassName('leaflet-control leaflet-draw')]
        //     el.map(e => {
        //         e.style.display = ''
        //     })
        //     setGrid({ width: 0, height: 0, tiles: [], zoom: null });
        //     setIsPrinting(false)
        //     setPrintingParams(null)
        //     dispatch(setStop(false))
        //     map.invalidateSize()

        // }



        var printMain = function () {
            setIsError({ color: 'limegreen', text: `Подготовка главной страницы` })
            // var w = grid.width
            // var h = grid.height
            var w = ((a4.width - 10) * MM_TO_INCH) * params.dpi;
            var h = ((a4.height - 10) * MM_TO_INCH) * params.dpi;
            var south = grid.tiles[0].bounds.getSouth()
            var north = grid.tiles[0].bounds.getNorth()
            var est = grid.tiles[0].bounds.getEast()
            var west = grid.tiles[0].bounds.getWest()
            grid.tiles.map(tile => {
                var tsouth = tile.bounds.getSouth()
                var tnorth = tile.bounds.getNorth()
                var test = tile.bounds.getEast()
                var twest = tile.bounds.getWest()
                if (south >= tsouth) south = tsouth
                if (north <= tnorth) north = tnorth
                if (est <= test) est = test
                if (west >= twest) west = twest
            })
            var b = new L.latLngBounds(new L.LatLng(south, west), new L.latLng(north, est))

            var app = document.getElementsByClassName('App')[0];
            app.style.width = `${w}px`
            app.style.height = `${h}px`;
            map.options.zoomDelta = 0.1
            map.options.zoomSnap = 0.1
            map.invalidateSize()
            map.fitBounds(b, { animate: true, padding: [w / 6, h / 6] })
            // map.flyToBounds(b, {animate: false})

            // map.zoomOut()
            setTimeout(() => {
                html2canvas(map.getContainer(), {
                    useCORS: true, // Если нужны кросс-доменные ресурсы
                    logging: true,
                    ignoreElements: document.getElementsByClassName('leaflet-control-container'),

                }).then(img => {
                    mainImage = img.toDataURL("image/png", 1.0);
                    if (isPrintingRef.current) {
                        // if (params.statement) {
                        //     printPillarsStatements()
                        // } else {
                        printOverViews(0)
                        // }

                    } else {

                        revert()
                    }

                })

            }, params.dpi * 10)
        }

        // setTimeout(() => {
        //     printPillarsStatements()
        // }, 1000)

        if (params.statement) {
            printPillarsStatements()
        } else {
            printMain()
        }

        var printOverViews = function (i) {
            setIsError({ color: 'limegreen', text: `Подготовка обзорных изображений (${i + 1} из ${grid.tiles.length})` })
            var w = grid.width / 4
            var h = grid.height / 4
            var b = grid.tiles[i].bounds
            // var app = document.getElementsByClassName('App')[0];
            app.style.width = `${w}px`
            app.style.height = `${h}px`;
            map.invalidateSize()
            // map.fitBounds(new L.LatLngBounds(new L.latLng(b.getSouth() - 0.0005, b.getWest() - 0.0005), new L.latLng(b.getNorth() + 0.0005, b.getEast() + 0.0005)))
            map.fitBounds(b, { padding: [25, 25] })
            // map.setView(c, z - 0.4, {animate: false})
            setTimeout(() => {
                html2canvas(map.getContainer(), {
                    useCORS: true, // Если нужны кросс-доменные ресурсы
                    logging: true,
                    ignoreElements: document.getElementsByClassName('leaflet-control-container'),

                }).then(img => {
                    overViewImageUrls.push(img.toDataURL("image/png", 1.0));
                    if (!isPrintingRef.current) {
                        revert()
                    } else {
                        if (i < grid.tiles.length - 1) {
                            printOverViews(i + 1);
                        } else {
                            setPrintingParams(p => { return { ...p, overview: false } })
                            printRect(1)
                        }
                    }

                })
            }, params.dpi * 10)
        }



        var printRect = function (i) {
            map.eachLayer(l => {
                if (l.options.data === 'rex') map.removeLayer(l)
            })
            setIsError({ color: 'limegreen', text: `Подготовка страницы ${i} из ${grid.tiles.length}` })

            var t = grid.tiles.find(t => t.pageNumber === i)
            // var w = t.width
            // var h = t.height
            var w = grid.width
            var h = grid.height
            var c = t.center
            var z = grid.zoom
            // var app = document.getElementsByClassName('App')[0];
            app.style.width = `${w}px`
            app.style.height = `${h}px`;
            map.invalidateSize()

            map.setView(c, z, { animate: false });
            // const [west, south, east, north] = map.getBounds().toBBoxString()
            //     .split(',')
            //     .map(parseFloat);

            setTimeout(() => {
                html2canvas(map.getContainer(), {
                    useCORS: true, // Если нужны кросс-доменные ресурсы
                    logging: true,
                    ignoreElements: document.getElementsByClassName('leaflet-control-container'),

                }).then(img => {
                    imageUrls.push(img.toDataURL("image/png", 1.0));
                    if (i < grid.tiles.length && isPrintingRef.current) {
                        printRect(i + 1);
                    } else {
                        createPdf()

                        revert()

                        // createCSV()
                    }


                })

            }, params.dpi * 10 * (6 - parseInt(params.paperSize.charAt(1))))

        }
        function createCSV() {
            if (csvString && csvString.length > 1) {
                const date = new Date()
                const sdate = `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`

                const blob = new Blob(["\uFEFF" + csvString], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);

                link.setAttribute("href", url);
                link.setAttribute("download", `Поопорная ведомость`); // от ${sdate}
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        function createXLSX() {
            console.log(csv)
            if (csv && csv.length > 1) {
                const date = new Date()
                const sdate = `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`

                const INFO_ROW = csv[0].map(col => {
                    return {
                        value: col,
                        fontWeight: 'bold',
                        align: "center",
                        alignVertical: 'center',
                        borderStyle: 'thin'
                    }
                })

                const DATA_ROWS = csv.slice(1).map(row => {
                    return row.map((col, i) => {
                        return {
                            value: col,
                            align: "center",
                            alignVertical: 'center',
                            borderStyle: 'thin',
                            type: String
                        }

                    })
                })

                const columns = [
                    { width: 30 },
                    { width: 30 },
                    { width: 20 },
                ]


                console.log([INFO_ROW, ...DATA_ROWS])
                writeXlsxFile([INFO_ROW, ...DATA_ROWS], {
                    columns,
                    fileName: `Поопорная ведомость от ${sdate}.xlsx`,
                    fontFamily: 'Arial',
                    fontSize: 12
                });
            }
        }

        function createPdf() {
            setIsError({ color: 'limegreen', text: `Подготовка PDF` })
            var pdf;
            const w = paperWidth
            const h = paperHeight
            const orientation = params.orientation;

            // adding first page is the same as creating the PDF
            pdf = new jsPDF({ format: [a4.width, a4.height], orientation: orientation, compress: false });
            // pdf.addFileToVFS("roboto-light-normal.ttf", font)
            // pdf.addFont("roboto-light-normal.ttf", "Roboto-Light", "normal");
            pdf.setFont("Roboto-Medium");
            pdf.setFontSize(11);
            pdf.setLanguage('ru')


            const xOffset = 5
            const yOffset = 5
            const imageBottomOffset = 42
            const pageNumberWidth = 24
            const pageNumberHeigth = 8
            const textHeigth = 5
            const overViewWidth = orientation === 'landscape' ? 70 : 40
            const overViewHeight = 40
            const pagesCount = imageUrls.length + tableImages.reduce((t, r) => t + r.body.length, 0)
            let currentPage = 1
            // const legengWidth = 100
            // const legengHeight = 40
            if (mainImage) {
                pdf.addImage(mainImage, 'image/png', xOffset, yOffset, a4.width - (xOffset * 2), a4.height - (yOffset * 2), undefined, "MEDIUM");

                // pdf.rect(xOffset, yOffset, w - (xOffset * 2), h - (yOffset * 2))
                //Получаем список ТП
                let transformers = new Set()
                map.eachLayer(layer => {
                    if (layer.options.type) {
                        if (layer.options.type.includes('transformer')) {
                            transformers.add(layer.options.name)
                        }
                        if (layer.options.type === 'cluster') {
                            layer.getLayers().map(l => {
                                if (l.options.type && l.options.type.includes('transformer')) {
                                    transformers.add(l.options.name)
                                }
                            })
                        }
                    }
                })
                transformers = [...transformers]
                if (transformers.length > 0) {

                    pdf.setFontSize(11);
                    pdf.setTextColor('white')

                    const offsets = [-0.3, -0.2, -0.1, 0.1, 0.2, 0.3];
                    offsets.forEach(dx => {
                        offsets.forEach(dy => {
                            pdf.text(`Обзорный план объект${transformers.length === 1 ? 'а' : 'ов'}:`, xOffset * 2 + dx, yOffset * 2 + textHeigth + dy, { align: "left", baseline: "bottom", maxWidth: (a4.width * 0.3) - xOffset });
                        });
                    });
                    pdf.setTextColor('black')
                    pdf.text(`Обзорный план объект${transformers.length === 1 ? 'а' : 'ов'}:`, xOffset * 2, yOffset * 2 + textHeigth, { align: "left", baseline: "bottom", maxWidth: (a4.width * 0.3) - xOffset });

                    transformers.map((tr, i) => {
                        pdf.setTextColor('white')

                        offsets.forEach(dx => {
                            offsets.forEach(dy => {
                                pdf.text(`- ${tr}`, xOffset * 2 + dx, yOffset * 2 + (i + 2) * textHeigth + dy, { align: "left", baseline: "bottom", maxWidth: (a4.width * 0.3) - xOffset });
                            });
                        });
                        pdf.setTextColor('black')
                        pdf.text(`- ${tr}`, xOffset * 2, yOffset * 2 + (i + 2) * textHeigth, { align: "left", baseline: "bottom", maxWidth: (a4.width * 0.3) - xOffset });

                    })

                }
            }
            pdf.setTextColor('#8A8889')
            pdf.setFontSize(10);

            for (var i = 0; i < imageUrls.length; i++) {
                pdf.addPage([w, h], orientation);
                pdf.addImage(imageUrls[i], 'image/png', xOffset, yOffset, w - (xOffset * 2), h - (yOffset * 2) - imageBottomOffset, undefined, "MEDIUM");
                // pdf.text(`стр. ${currentPage} из ${pagesCount}`, w - xOffset, h - yOffset, { align: "right", baseline: "bottom" });
                currentPage = currentPage + 1
                pdf.addImage(overViewImageUrls[i], 'image/png', xOffset, h - yOffset - imageBottomOffset + 2, overViewWidth, overViewHeight, undefined, "MEDIUM");

            }
            const date = new Date()
            const sdate = `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`
            //Итерация по таблицам
            if (params.accounting) {
                const nePixel = map.project(bounds.getNorthEast());
                const swPixel = map.project(bounds.getSouthWest());

                const filteredData = data.map(item => {
                    const pillars = item.pillars.map(pillar => {
                        const markPixel = map.project(pillar.coords)
                        if ((markPixel.x < swPixel.x) || (markPixel.x > nePixel.x) || (markPixel.y < nePixel.y) || (markPixel.y > swPixel.y)) return null
                        if (params.accountingFilter === 'codes') {
                            const checklist = pillar.accounting.checklist?.filter(code => checklistFilter.includes(code)) || null
                            if (!checklist || checklist.length === 0) return null
                            return {
                                ...pillar,
                                accounting: {
                                    ...pillar.accounting,
                                    checklist
                                }
                            }
                        }
                        return pillar
                    }).filter(f => f)
                    if (!pillars || pillars.length === 0) return null
                    return {
                        ...item,
                        pillars
                    }
                }).filter(f => f)

                const groupedByObjects = {};
                filteredData.forEach(item => {
                    const objectName = item.ps && item.tp ? `${item.ps.name} ${item.ps.operating_voltage} ${item.tp.name} ${item.tp.town}` : 'Неизвестный объект';

                    if (!groupedByObjects[objectName]) {
                        groupedByObjects[objectName] = [];
                    }

                    item.pillars.forEach(pillar => {
                        groupedByObjects[objectName].push(pillar);
                    });
                });


                // Сортируем группы по названию проекта
                const sortedGroups = Object.keys(groupedByObjects).sort();

                // Создаем PDF документ
                // const pdf = new jsPDF('landscape', 'mm', 'a4');
                // pdf.setFont("arial", "normal");
                // pdf.setLanguage('ru')

                // Настройки страницы
                // const pageWidth = pdf.internal.pageSize.getWidth();
                // const pageHeight = pdf.internal.pageSize.getHeight();
                const margin = 5;
                // const contentWidth = pageWidth - 2 * margin;
                // const contentHeight = pageHeight - 2 * margin;

                // Заголовок документа
                // pdf.setFontSize(16);
                // pdf.setFont("arial", "normal");
                // pdf.setTextColor(150, 54, 52);
                // pdf.text('Предписания авторского надзора ООО "КОМОКС"', pageWidth / 2, 10, { align: 'center' });

                // Информация о документе
                // pdf.setFontSize(10);
                // pdf.setFont("arial", "normal");
                // pdf.setTextColor(100, 100, 100);
                // const currentDate = new Date().toLocaleDateString('ru-RU');
                // pdf.text(`Дата экспорта: ${currentDate}`, pageWidth - margin, 15, { align: 'right' });
                // pdf.text(`Всего объектов: ${groupedData.groupCounts.length}`, margin, 15);

                let currentY = 10;
                let pageNumber = 1;
                // let totalPages = 1; // Будет обновлено после создания всех страниц

                pdf.addPage([a4.width, a4.height], orientation)
                // pdf.text(`Приложение №${pageNumber} - Предписания Авторского надзора ООО «КОМОКС» на ${sdate}`, a4.width - xOffset, yOffset, { align: "right", baseline: "top" });

                // Определяем заголовки таблицы (как в Excel)
                const headers = [
                    { content: '№', colSpan: 1 },
                    { content: 'Номер опоры', colSpan: 1 },
                    { content: 'Готово/Отклонено', colSpan: 3 },
                    { content: 'Устранено', colSpan: 2 },
                    { content: 'Коды чек-листа', colSpan: 1 },
                    { content: 'Описание кодов чек-листа', colSpan: 1 },
                    { content: 'Указания и сроки их выполнения', colSpan: 1 },
                    { content: 'Стоимость', colSpan: 1 },
                    { content: 'Отметка о выполнении', colSpan: 1 },
                    { content: 'Авторский надзор', colSpan: 1 },
                ];

                // Добавляем данные по группам
                sortedGroups.forEach((objectName, objectIndex) => {
                    const objectData = groupedByObjects[objectName];

                    // Проверяем, нужно ли добавить новую страницу
                    // if (currentY > a4.height - 80) {
                    //     pdf.addPage([a4.width, a4.height], orientation)
                    //     pageNumber++;
                    //     currentY = 15;
                    // }

                    // // Заголовок проекта (как в Excel - с заливкой)
                    // pdf.setFontSize(11);
                    // pdf.setFont("arial", "bold");
                    // pdf.setTextColor(0, 0, 0);

                    // // Рисуем фон для заголовка проекта (светло-голубой как в Excel)
                    // pdf.setFillColor(242, 220, 219); // E6F3FF
                    // pdf.rect(margin, currentY - 3, a4.width - 2 * margin, 8, 'F');

                    // // Рисуем границы
                    // pdf.setDrawColor(208, 215, 224); // D0D7E0
                    // pdf.setLineWidth(0.1);
                    // pdf.rect(margin, currentY - 3, a4.width - 2 * margin, 8);

                    // pdf.text(objectName, a4.width / 2, currentY + 2, { align: 'center' });
                    // currentY += 10;

                    const tableData = [
                        [{ content: objectName, colSpan: 13, styles: { halign: 'center', fontStyle: 'bold', fontSize: 9 } }]
                    ]

                    objectData.forEach(item => {
                        const accounting = item.accounting;
                        if (!accounting) return;

                        // Обработка множественных checklist элементов
                        if (accounting.checklist && accounting.checklist.length > 0) {
                            // Создаем строку для каждого элемента checklist
                            accounting.checklist.forEach((checklistCode, index) => {
                                const rule = rulesMap[checklistCode];
                                if (!rule) return;

                                // Получаем статус из status_log для конкретного checklist item
                                const statusLog = accounting.status_log?.[checklistCode];
                                const _statusLog = accounting._status_log?.[checklistCode];
                                const part_elimin_categ = accounting.part_elimin_categ || { ready: [], success: [], rejected: [] };

                                // Определяем статусы ready/rejected/success
                                const isReady = statusLog?.ready || part_elimin_categ.ready?.includes(checklistCode) || false;
                                const isRejected = statusLog?.rejected || part_elimin_categ.rejected?.includes(checklistCode) || false;
                                const isSuccess = statusLog?.success || part_elimin_categ.success?.includes(checklistCode) || false;

                                // Формируем данные для готово/отклонено
                                let readyRejectedStatus = '';
                                let readyRejectedDate = '';
                                let rejectionReason = '';
                                let readyRejectedUser = '';

                                if (isRejected) {
                                    readyRejectedStatus = 'Отклонено';
                                    rejectionReason = statusLog.reason;
                                    if (_statusLog && (statusLog?.ready || statusLog?.rejected)) {
                                        readyRejectedDate = _statusLog.date || '';
                                        readyRejectedUser = _statusLog.user ? `${_statusLog.user.short_fio} (${_statusLog.user.post_for_select})` : '';
                                    }
                                } else if (isReady) {
                                    readyRejectedStatus = 'Готово к проверке';
                                    if (_statusLog && (statusLog?.ready || statusLog?.rejected)) {
                                        readyRejectedDate = _statusLog.date || '';
                                        readyRejectedUser = _statusLog.user ? `${_statusLog.user.short_fio} (${_statusLog.user.post_for_select})` : '';
                                    }
                                }

                                // Формируем данные для устранено
                                let successStatus = '';
                                let successDate = '';
                                let successUser = '';

                                if (isSuccess) {
                                    successStatus = 'Устранено';
                                    if (_statusLog && statusLog?.success) {
                                        successDate = _statusLog.date || '';
                                        successUser = _statusLog.user ? `${_statusLog.user.short_fio} (${_statusLog.user.post_for_select})` : '';
                                    }
                                }

                                tableData.push([
                                    accounting.id,
                                    item.name,
                                    readyRejectedStatus,
                                    [readyRejectedDate, readyRejectedUser].join('\n'),
                                    rejectionReason,
                                    successStatus,
                                    [successDate, successUser].join('\n'),
                                    checklistCode,
                                    rule.name || '',
                                    rule.description || '',
                                    new Intl.NumberFormat('ru-RU', {
                                        style: 'currency',
                                        currency: 'RUB',
                                    }).format(rule.cost || 0),
                                    [accounting.status, accounting.status_date].join('\n'),
                                    [`${accounting.creator.short_fio} (${accounting.creator.post_for_select})`, accounting.created].join('\n') || ''
                                ]);
                            });
                        }

                    });



                    // Добавляем таблицу с улучшенным форматированием
                    autoTable(pdf, {
                        head: [headers],
                        body: tableData,
                        startY: currentY,
                        margin: { left: margin, right: margin },
                        pageBreak: 'auto',
                        rowPageBreak: 'avoid',
                        styles: {
                            fontSize: 8,
                            cellPadding: 1,
                            lineColor: [208, 215, 224], // D0D7E0 - как в Excel
                            lineWidth: 0.1,
                            textColor: [0, 0, 0],
                            font: 'arial',
                            fontStyle: 'normal'
                        },
                        headStyles: {
                            fillColor: [150, 54, 52], // Синий заголовок как в Excel
                            textColor: [255, 255, 255],
                            font: 'arial',
                            fontStyle: 'bold',
                            fontSize: 9,
                            cellPadding: 1,
                            halign: 'center',
                            valign: 'middle'
                        },
                        alternateRowStyles: {
                            fillColor: [242, 220, 219] // E6F3FF - светло-голубой для четных строк
                        },
                        columnStyles: {
                            0: { cellWidth: 10, valign: 'middle', halign: 'center' },   // №
                            1: { cellWidth: 28, valign: 'middle', halign: 'center' },  // Номер опоры
                            2: { cellWidth: 20, valign: 'middle', halign: 'center' },  // Готово/Отклонено
                            3: { cellWidth: 24, valign: 'middle', halign: 'center' },  // Готово/Отклонено
                            4: { cellWidth: 20, valign: 'middle', halign: 'center' },  // Готово/Отклонено
                            5: { cellWidth: 20, valign: 'middle', halign: 'center' },  // Устранено
                            6: { cellWidth: 24, valign: 'middle', halign: 'center' },  // Устранено
                            7: { cellWidth: 16, valign: 'middle', halign: 'center' },  // Коды чек-листа
                            8: { cellWidth: 30, valign: 'middle' },  // Описание кодов чек-листа
                            9: { cellWidth: 38, valign: 'middle' },  // Указания и сроки их выполнения
                            10: { cellWidth: 12, valign: 'middle', halign: 'center' },  // Стоимость
                            11: { cellWidth: 22, valign: 'middle', halign: 'center' },  // Отметка о выполнении
                            12: { cellWidth: 24, valign: 'middle', halign: 'center' },  // Авторский надзор

                        },
                        didDrawPage: function (data) {
                            // Функция будет вызвана для каждой страницы, но номера добавим позже
                        }
                    });

                    // Получаем позицию после таблицы
                    const tableEndY = pdf.lastAutoTable ? pdf.lastAutoTable.finalY : currentY + 50;
                    currentY = tableEndY + 5;

                    // Не добавляем разделитель между проектами (как в Excel)
                });
            }

            const totalPages = pdf.getNumberOfPages()

            for (let pageNum = 2; pageNum <= totalPages; pageNum++) {
                pdf.setPage(pageNum);

                // Добавляем номер страницы внизу
                pdf.setFontSize(8);
                pdf.setFont("arial", "normal");
                pdf.setTextColor(100, 100, 100);
                // pdf.text(`Стр. ${pageNum} из ${totalPages}`,  - margin, pageHeight - 5, { align: 'right' });

                if (pageNum > currentPage) {
                    pdf.text(`Приложение №${pageNum - currentPage} - Предписания Авторского надзора ООО «КОМОКС» на ${sdate}`, a4.width - xOffset, yOffset, { align: "right", baseline: "top" });
                    pdf.text(`Cтр. ${pageNum - 1} из ${totalPages - 1}`, a4.width - xOffset, a4.height - yOffset, { align: "right", baseline: "bottom" });
                } else {
                    pdf.text(`Cтр. ${pageNum - 1} из ${totalPages - 1}`, w - xOffset, h - yOffset, { align: "right", baseline: "bottom" });
                }
            }
            // for (let i = 0; i < tableImages.length; i++) {
            //     //Итерация по страницам таблицы
            //     for (let y = 0; y < tableImages[i].body.length; y++) {
            //         pdf.addPage([a4.width, a4.height], orientation)
            //         //Колонтитул

            //         pdf.text(`Приложение №${i + 1} - Предписания Авторского надзора ООО «КОМОКС» на ${sdate}`, a4.width - xOffset, yOffset, { align: "right", baseline: "top" });

            //         //Заглавие таблицы
            //         pdf.addImage(tableImages[i].header.url, 'image/png', xOffset, yOffset + textHeigth, a4.width - (xOffset * 2), tableImages[i].header.height, undefined, "MEDIUM");
            //         //Тело таблицы
            //         pdf.addImage(tableImages[i].body[y].url, 'image/png',
            //             xOffset,
            //             yOffset + tableImages[i].header.height + textHeigth,
            //             a4.width - (xOffset * 2),
            //             tableImages[i].body[y].height,
            //             undefined,
            //             "MEDIUM");
            //         // pdf.rect(xOffset, yOffset, w - (xOffset * 2), h - (yOffset * 2))
            //         pdf.text(`стр. ${currentPage} из ${pagesCount}`, a4.width - xOffset, a4.height - yOffset, { align: "right", baseline: "bottom" });
            //         currentPage = currentPage + 1
            //     }
            // }
            pdf.save(`Карта от ${sdate}.pdf`)
            revert()
        }

        async function printPillarsStatements() {
            map.fire('viewreset')
            map.invalidateSize()

            let pillars = []
            // let transformers = []
            let fiders = []
            map.eachLayer(layer => {
                if (layer.options.type) {
                    if (layer.options.type.includes('pillar') && !pillars.find(p => p.data === layer.options.data)) pillars.push(layer.options)
                    // if (layer.options.type.includes('transformer')) transformers.push(layer.options)
                    if (layer.options.type.includes('fider')) fiders.push(layer.options)
                    if (layer.options.type === 'cluster') {
                        layer.getLayers().map(l => {
                            if (l.options.type) {
                                if (l.options.type.includes('pillar') && !pillars.find(p => p.data === layer.options.data)) pillars.push(l.options)
                                // if (layer.options.type.includes('transformer')) transformers.push(layer.options)
                            }
                        })
                    }
                }
            })
            console.log(pillars)
            // console.log(fiders)
            console.log(transformers)
            //Разбиваем опоры по фидерам
            // if (fiders && fiders.length > 0) {
            //     fiders = fiders.map(fider => {
            //     console.log(fider)  
            //     return {
            //         ...fider,
            //         // connected: fider.connected.filter(conn => pillars.find(pill => pill.data === conn.id && conn.type === 'pillar')),
            //         pillars: fider.connected?.map(conn => pillars.find(p => Number(conn.id) === Number(p.data) && conn.type === 'pillar')).filter(f => f) || [],
            //         transformer: transformers.find(ktp => Number(fider.tp_id) === ktp.fid)
            //     }}).filter(f => f.pillars.length > 0)
            // }
            console.log(fiders)

            const workbook = new ExcelJS.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.title = 'Поопорная ведомость';

            // Создаем лист
            const worksheet = workbook.addWorksheet('Поопорная ведомость');

            // Закрепляем первую строку (общие заголовки)
            worksheet.views = [
                { state: 'frozen', ySplit: 1 }
            ];


            // Закрепление заголовков будет обновлено после добавления информационных строк

            // Определяем заголовки колонок
            const headers = [
                'Номер опоры (тип опоры)',
                'Номер опоры  (тип опоры)',
                'Длина пролета, м',
                'Широта',
                'Долгота',
                'x',
                'y'
            ];

            const fiderChangeAllow = {
                'fider04': ['fider04', 'fider10-04'],
                'fider6': ['fider6', 'fider10-04'],
                'fider10': ['fider10', 'fider10-04'],
                'fider10-04': ['fider10', 'fider04', 'fider10-04'],
            }

            const pillarChangeAllow = {
                'pillar04': ['pillar04', 'pillar04-10'],
                'pillar6': ['pillar6', 'pillar04-10'],
                'pillar10': ['pillar10', 'pillar04-10'],
                'pillar04-10': ['pillar10', 'pillar04', 'pillar04-10'],
            }

            // Строим дерево для каждого фидера
            console.log('Строим деревья электросети для каждого фидера...');
            const tree = []
            const pairs = []

            const ktps = transformers.filter(ktp => pillars.find(f => Number(f.tp_id) === ktp.fid))

            for (const ktp of ktps) {
                let localPillars = pillars.filter(p => Number(p.tp_id) === ktp.fid)
                localPillars = localPillars.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.data === value.data
                    ))
                )
                console.log("Трансформатор: " + ktp.name)
                const ktpPos = new L.latLng(ktp.coords)
                const ktpName = `${ktp.name}${ktp.nickname ? '(' + ktp.nickname + ')' : ''} ${ktp.town}`
                const ktpTree = []
                const visited = new Set()

                async function createSubtreeIterative(startPillar) {
                    const stack = [startPillar]
                    let prevPillar = null
                    // const visited = new Set()

                    while (stack.length > 0) {
                        const currentPillar = stack.pop()

                        if (visited.has(currentPillar.data)) continue
                        visited.add(currentPillar.data)
                        if (currentPillar.connected && currentPillar.connected.length > 0 && fiders.length > 0) {
                            currentPillar.connected.forEach(c => {
                                console.log(currentPillar.type)
                                if (!c || !c.type === 'pillar' || visited.has(c.id) || currentPillar.data === c.id) return



                                const toPillar = localPillars.find(p => p.data === c.id)
                                if (!toPillar) return
                                if (!pillarChangeAllow[currentPillar.type].includes(toPillar.type)) {
                                    if (prevPillar?.type !== toPillar.type) return
                                }
                                pairs.push({
                                    from: currentPillar,
                                    to: toPillar,
                                    transformer: false,
                                    distance: currentPillar.pos.distanceTo(toPillar.pos)
                                })
                                console.log(currentPillar.name, toPillar.name)

                                if (!visited.has(toPillar.data)) {
                                    stack.push(toPillar)
                                }

                            })
                        } else {
                            pairs.push({
                                from: currentPillar,
                                to: null,
                                transformer: false,
                                distance: null
                            })
                        }
                        prevPillar = currentPillar

                    }
                }



                let rootPillars = localPillars.filter(p => p.connected.find(c => c.type === 'transformer' && c.id === ktp.fid))
                console.log(rootPillars)
                if (fiders.length > 0) {
                    for (const pillar of rootPillars) {
                        if (pillar.connected.find(c => c.type === 'transformer' && c.id === ktp.fid)) {
                            pairs.push({
                                from: {
                                    ...ktp,
                                    pos: ktpPos,
                                    xy: convertWGS84ToMSK05(ktpPos.lat, ktpPos.lng)
                                },
                                to: pillar,
                                transformer: true,
                                distance: ktpPos.distanceTo(pillar.pos)
                            })
                        }
                        await createSubtreeIterative(pillar)
                    }
                }

                console.log(visited)
                let notVisited = localPillars.filter(p => !visited.has(p.data))
                // notVisited.sort((a, b) => a.pos.distanceTo(ktpPos) - b.pos.distanceTo(ktpPos))
                notVisited.sort((a, b) => {
                    const aNumber = a.name.match(/\d+\./g) ?? [0]
                    const bNumber = b.name.match(/\d+\./g) ?? [0]
                    if (!aNumber || !bNumber) return a.name.localeCompare(b.name)
                    return parseInt(aNumber) - parseInt(bNumber)
                })
                console.log(notVisited)

                // Только после завершения rootPillars обрабатываем notVisited
                for (const pillar of notVisited) {
                    await createSubtreeIterative(pillar)
                }
                console.log(pairs)
                // console.log(rootPillars)
                // rootPillars.forEach(pillar => {
                //     if (pillar.connected.find(c => c.type === 'transformer' && c.id === ktp.fid)) {
                //         pairs.push({
                //             from: ktp.name,
                //             to: pillar.name,
                //             transformer: true
                //         })
                //     }
                //     createSubtreeIterative(pillar)

                // })
                // console.log(visited)
                // let notVisited = localPillars.filter(p => !visited.has(p.data))
                // notVisited.sort((a, b) => a.pos.distanceTo(ktpPos) - b.pos.distanceTo(ktpPos))
                // console.log(notVisited)
                // notVisited.forEach(pillar => {
                //     createSubtreeIterative(pillar)
                // })

                pairs.forEach(pair => {
                    if (!tree[ktpName]) tree[ktpName] = {}
                    if (pair.transformer) {
                        let fiderNumber = '-1'
                        const matchNumber = pair.to.name?.match(/Ф\d[А-Я]*-/g)
                        if (matchNumber && matchNumber.length > 0) {
                            fiderNumber = matchNumber[0]?.replace('Ф', '')?.replace('-', '')
                        }
                        let fiderType = pair.to.type
                        if (!tree[ktpName][fiderType]) tree[ktpName][fiderType] = {}
                        if (!tree[ktpName][fiderType][fiderNumber]) tree[ktpName][fiderType][fiderNumber] = []
                        tree[ktpName][fiderType][fiderNumber].push(pair)
                    } else {
                        let fiderNumber = '-1'
                        // let fiderNumberFrom = '-1'
                        // let fiderNumberTo = '-1'
                        const matchNumberFrom = pair.from.name?.match(/Ф\d[А-Я]*-/g)
                        // const matchNumberTo = pair.to.name?.match(/Ф\d[А-Я]*-/g)
                        if (matchNumberFrom && matchNumberFrom.length > 0) {
                            fiderNumber = matchNumberFrom[0]?.replace('Ф', '')?.replace('-', '')
                        }
                        // if (fiderNumberTo && fiderNumberTo.length > 0) {
                        //     fiderNumberTo = fiderNumberTo[0]?.replace('Ф', '')?.replace('-', '')
                        // }


                        let fiderType = pair.from.type
                        if (!tree[ktpName][fiderType]) tree[ktpName][fiderType] = {}
                        if (!tree[ktpName][fiderType][fiderNumber]) tree[ktpName][fiderType][fiderNumber] = []
                        tree[ktpName][fiderType][fiderNumber].push(pair)
                    }
                })

            }
            console.log(tree)
            // revert()
            // return







            let allRows = [];
            let objectRows = []

            const types = {
                'fider04': '(0,4кВ)',
                'fider6': '(6кВ)',
                'fider10': '(10кВ)',
                'fider10-04': '(0,4-10кВ)',
                'pillar04': '(0,4кВ)',
                'pillar6': '(6кВ)',
                'pillar10': '(10кВ)',
                'pillar10-04': '(0,4-10кВ)',
                'pillar04-10': '(0,4-10кВ)',
            }

            // Группируем данные по объектам как в react-virtuoso
            Object.entries(tree).forEach(([keyTp, valueTp]) => {
                console.log(keyTp)
                Object.entries(valueTp).sort((a, b) => a[0].localeCompare(b[0])).forEach(([keyType, valueType]) => {
                    console.log(keyType)
                    Object.entries(valueType).forEach(([keyFider, valueFider]) => {
                        console.log(keyFider, valueFider)
                        let objectName = [keyTp, 'Фидер', keyFider === '-1' ? null : keyFider, types[keyType]].filter(f => f).join(' ')
                        const projectRow = [objectName];
                        allRows.push(projectRow);
                        objectRows.push(allRows.length + 1)
                        valueFider.forEach(item => {
                            allRows.push([
                                item.from.name,
                                item.to?.name || '',
                                item.distance ? Number(item.distance.toFixed(2)) : '',
                                item.from.pos.lat,
                                item.from.pos.lng,
                                item?.from?.xy[0],
                                item?.from?.xy[1]
                            ])
                        })


                    })
                })
            });





            const endRow = allRows.length + 1; // +1 для заголовков
            worksheet.addTable({
                name: 'PillarsStatements',
                ref: `A1:O${endRow}`,
                headerRow: true,
                totalsRow: false,
                style: { theme: 'TableStyleLight5', showRowStripes: true },
                columns: headers.map(h => ({ name: h, filterButton: true })),
                rows: allRows
            });
            const colWidths = [30, 30, 15, 15, 15, 18, 18]
            const centerCols = [1, 2, 3, 4, 5, 6, 7]


            // Устанавливаем ширину столбцов
            colWidths.forEach((width, index) => {
                const column = worksheet.getColumn(index + 1);
                column.width = width;
            });

            // const dateCols = [4, 8, 15, 17]
            // dateCols.forEach(colNumber => {
            //     const column = worksheet.getColumn(colNumber);
            //     column.numFmt = 'dd/mm/yyyy'
            // })

            // const currencyCols = [13]
            // currencyCols.forEach(colNumber => {
            //     const column = worksheet.getColumn(colNumber);
            //     column.numFmt = '# ##0.00'
            // })

            const distanceCol = [3]
            distanceCol.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = '0.00'
            })

            const coorsdCols = [4, 5, 6, 7]
            coorsdCols.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = '0.000000000'
            })

            // const textCols = [2, 3, 5, 6, 7, 9, 10, 11, 12, 14, 16]
            // textCols.forEach(colNumber => {
            //     const column = worksheet.getColumn(colNumber);
            //     column.numFmt = ''
            // })



            // Устанавливаем черный цвет текста для всех ячеек таблицы
            for (let rowNumber = 1; rowNumber <= endRow; rowNumber++) {
                const row = worksheet.getRow(rowNumber);
                // row.height = undefined

                row.eachCell((cell, colNumber) => {
                    let color = 'FF000000'
                    // if (statusCols.includes(colNumber) && rowNumber !== 1) color = statuses[cell.text]?.argb || 'FF000000'
                    // if (colNumber === codeCol) color = codeColors[cell.text[0]] || 'FF000000'
                    cell.font = {
                        ...cell.font,
                        name: 'Arial',
                        size: objectRows.includes(rowNumber) || rowNumber === 1 ? 11 : 10,
                        bold: objectRows.includes(rowNumber) || rowNumber === 1,
                        color: { argb: color } // Черный цвет

                    };
                    cell.alignment = {
                        horizontal: !objectRows.includes(rowNumber) && (rowNumber === 1 || centerCols.includes(colNumber)) ? 'center' : 'left',
                        vertical: 'middle',
                        wrapText: !objectRows.includes(rowNumber) || rowNumber == 1 ? true : false
                    }


                });
                row.height = undefined; // Это включает автоподбор

                if (typeof row.commit === 'function') row.commit();
            }


            // Генерируем имя файла с текущей датой
            const now = new Date();
            const dateStr = now.toISOString().split('T')[0];
            const fileName = `Поопорная ведомость от ${dateStr}.xlsx`;

            // Экспортируем файл
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);


            revert()
            // printOverViews(0)
            // createXLSX()
        }




    }






    useEffect(() => {
        calculateGrid();
    }, [calculateGrid]);



    useEffect(() => {
        isPrintingRef.current = isPrinting;
        if (isPrinting) printMap()
    }, [isPrinting]);



    function getTileCenterForText(tile) {
        const bounds = map.getBounds()
        const n = bounds.getNorth();
        const s = bounds.getSouth();
        const e = bounds.getEast();
        const w = bounds.getWest();

        const tileBounds = tile.bounds
        let tilen = tileBounds.getNorth();
        let tiles = tileBounds.getSouth();
        let tilee = tileBounds.getEast();
        let tilew = tileBounds.getWest();

        if (tiles < s) tiles = s
        if (tilen > n) tilen = n
        if (tilee > e) tilee = e
        if (tilew < w) tilew = w

        return new L.LatLngBounds(new L.latLng(tiles, tilew), new L.latLng(tilen, tilee)).getCenter()

    }

    if (hide) {
        return null
    }

    return (
        <>

            {createPortal(
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'end', justifyContent: 'start', zIndex: 1202, pointerEvents: 'auto', order: 4, width: 'fit-content' }}>
                    {!polygon &&
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'end', justifyContent: 'center', zIndex: 1202, pointerEvents: 'auto', order: 1 }}>
                            <Tooltip title={isDrawing ? 'Отмена' : 'Печать'} placement='right' arrow>
                                <Paper
                                    elevation={3}
                                    sx={{
                                        display: 'flex',
                                        order: 1,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: window.innerWidth < 768 ? 26 : 30,
                                        height: window.innerWidth < 768 ? 26 : 30,
                                        // m: '10px 10px 5px 5px',
                                        opacity: 0.9,
                                        bgcolor: 'rgb(40, 40, 40)',
                                        boxShadow: isDrawing ? '0 0 3px 3px rgb(0, 174, 255)' : '0px 2px 6px grey',
                                        color: 'white',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                        '&:hover': {
                                            bgcolor: 'rgb(50, 50, 50)',
                                            transform: 'scale(1.1)',

                                        },
                                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsDrawing(!isDrawing)
                                        setIsPrinting(false)
                                        setPolygon(null)
                                        map.fire('signal:drawing', { source: 'print', state: false })
                                        // setTimeout(() => {
                                        //     drawingRef.current.enable()
                                        // }, 100)
                                    }}

                                >

                                    {isDrawing ? <CloseOutlinedIcon sx={{ fontSize: 24 }} /> : <LocalPrintshopOutlinedIcon style={{ fontSize: '22px' }} />}
                                </Paper>
                            </Tooltip>
                            {isDrawing &&
                                <Paper
                                    elevation={3}
                                    sx={{
                                        display: 'flex',
                                        order: 2,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: window.innerWidth < 768 ? 26 : 30,
                                        // m: '10px 10px 5px 5px',
                                        opacity: 0.9,
                                        bgcolor: 'rgb(40, 40, 40)',
                                        boxShadow: '0px 2px 6px grey',
                                        color: 'white',
                                        padding: '0px 10px',
                                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                                    }}

                                >

                                    <Typography variant="body2" sx={{ fontSize: window.innerWidth > 768 ? '0.8rem' : '0.75rem', fontWeight: 'bold', lineHeight: 1 }}>
                                        {'Нарисуйте участок для печати'}
                                    </Typography>

                                </Paper>
                            }
                        </Box>
                    }

                </Box>
                , document.getElementById(window.innerWidth < 768 ? "map-controls-left-bottom-first-row-left" : "map-controls-left-bottom")
            )
            }
            {
                polygon && createPortal(
                    <>
                        <Paper
                            elevation={3}
                            ref={settingsRef}
                            sx={{
                                position: 'absolute',
                                bottom: '10px',
                                left: '10px',
                                // transform: 'translateX(-50%)',
                                zIndex: isPrinting ? 10001 : 1700,
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                color: 'white',
                                borderRadius: '8px',
                                pointerEvents: 'auto',
                                minWidth: '300px',
                                maxWidth: '400px',
                                opacity: 0.9,
                                transform: window.innerWidth < 768 ? 'scale(0.7)' : null,
                                transformOrigin: 'left bottom'
                            }}
                        >
                            {/* Header */}
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '5px 10px',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                            }}>
                                <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                                    Настройки печати
                                </Typography>
                                {!isPrinting && (
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            revert()
                                            // setBounds(null)
                                            // setGrid({ width: 0, height: 0, tiles: [], dpi: null })
                                            // map.eachLayer(l => {
                                            //     if (l.options.data === 'rex' || l.options.data === 'rexd') map.removeLayer(l)
                                            // })
                                            // setHidden(true)
                                            // const el = [...document.getElementsByClassName('leaflet-control leaflet-draw')]
                                            // el.map(e => {
                                            //     e.style.display = ''
                                            // })


                                        }}
                                        sx={{ color: 'white', padding: '0px' }}
                                    >
                                        <CloseOutlinedIcon sx={{ fontSize: '18px' }} />
                                    </IconButton>
                                )}
                            </Box>

                            {/* Form Content */}
                            <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                {/* Scale */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Typography sx={{ fontSize: '12px', minWidth: '80px' }}>
                                        Масштаб 1:
                                    </Typography>
                                    <TextField
                                        type="number"
                                        value={params.scale}
                                        disabled={isPrinting}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Разрешаем пустые значения во время редактирования
                                            if (value === '' || value === '0') {
                                                setParams(p => { return { ...p, scale: value } })
                                            } else {
                                                try {
                                                    const v = Number(value)
                                                    if (v > 0) {
                                                        setParams(p => { return { ...p, scale: v } })
                                                    }
                                                } catch (err) {
                                                    // Игнорируем ошибки преобразования
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            // При потере фокуса устанавливаем минимальное значение если поле пустое
                                            const value = e.target.value;
                                            if (value === '' || value === '0' || Number(value) <= 0) {
                                                setParams(p => { return { ...p, scale: 1000 } })
                                            }
                                        }}
                                        slotProps={{
                                            input: {
                                                min: 1,
                                                step: 100
                                            }
                                        }}
                                        sx={{
                                            width: '100px',
                                            '& .MuiOutlinedInput-root': {
                                                height: '32px',
                                                '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.3)' },
                                                '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                                '&.Mui-focused fieldset': { borderColor: 'white' },
                                                '&.Mui-disabled fieldset': { borderColor: 'rgba(255, 255, 255, 0.4)' }
                                            },
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                                fontSize: '12px',
                                                padding: '4px 8px',
                                                '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.7)', WebkitTextFillColor: 'rgba(255, 255, 255, 0.7)' }
                                            }
                                        }}
                                    />
                                </Box>

                                {/* DPI */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                    <Typography sx={{ fontSize: '12px', minWidth: '80px' }}>
                                        DPI:
                                    </Typography>
                                    <TextField
                                        type="number"
                                        value={params.dpi}
                                        disabled={isPrinting}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Разрешаем пустые значения во время редактирования
                                            if (value === '' || value === '0') {
                                                setParams(p => { return { ...p, dpi: value } })
                                            } else {
                                                try {
                                                    const v = Number(value)
                                                    if (v > 0) {
                                                        setParams(p => { return { ...p, dpi: v } })
                                                    }
                                                } catch (err) {
                                                    // Игнорируем ошибки преобразования
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            // При потере фокуса устанавливаем минимальное значение если поле пустое
                                            const value = e.target.value;
                                            if (value === '' || value === '0' || Number(value) <= 0) {
                                                setParams(p => { return { ...p, dpi: 150 } })
                                            }
                                        }}
                                        slotProps={{
                                            input: {
                                                min: 10,
                                                max: 500,
                                                step: 10
                                            }
                                        }}
                                        sx={{
                                            width: '100px',
                                            '& .MuiOutlinedInput-root': {
                                                height: '32px',
                                                '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.3)' },
                                                '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                                '&.Mui-focused fieldset': { borderColor: 'white' },
                                                '&.Mui-disabled fieldset': { borderColor: 'rgba(255, 255, 255, 0.4)' }
                                            },
                                            '& .MuiInputBase-input': {
                                                color: 'white',
                                                fontSize: '12px',
                                                padding: '4px 8px',
                                                '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.7)', WebkitTextFillColor: 'rgba(255, 255, 255, 0.7)' }
                                            }
                                        }}
                                    />
                                    <Typography sx={{
                                        fontSize: '12px',
                                        color: `hsl(${Math.min(Math.floor((140 - 0) * (grid.zoom - 0) / (18 - 0)), 140)}, 100%, 50%)`
                                    }}>
                                        Зум: {grid.zoom ? grid.zoom : '0'}
                                    </Typography>
                                </Box>

                                {/* Paper Format */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                    <Typography sx={{ fontSize: '12px', minWidth: '80px' }}>
                                        Формат:
                                    </Typography>
                                    <FormControl sx={{
                                        minWidth: '80px',
                                        '& .Mui-disabled': {
                                            color: 'rgba(255, 255, 255, 0.7) !important'
                                        },
                                        '& .MuiSelect-select.Mui-disabled': {
                                            color: 'rgba(255, 255, 255, 0.7) !important',
                                            WebkitTextFillColor: 'rgba(255, 255, 255, 0.7) !important'
                                        }
                                    }}>
                                        <Select
                                            value={params.paperSize}
                                            disabled={isPrinting}

                                            onChange={(e) => {
                                                setParams(p => { return { ...p, paperSize: e.target.value } })
                                            }}
                                            slotProps={{
                                                input: {
                                                    sx: {
                                                        '&.Mui-disabled': {
                                                            color: 'rgba(255, 255, 255, 0.7) !important',
                                                            WebkitTextFillColor: 'rgba(255, 255, 255, 0.7) !important'
                                                        },
                                                        '& .MuiSelect-select': {
                                                            py: { xs: 0.75, md: 1 }
                                                        }
                                                    }
                                                }
                                            }}
                                            sx={{
                                                height: '32px',
                                                fontSize: { xs: '0.65rem', md: '0.8rem' },
                                                color: 'white',
                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' },
                                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                                                '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                                                '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.7) !important' },
                                                '&.Mui-disabled .MuiSelect-select': { color: 'rgba(255, 255, 255, 0.7)' },
                                                '& .MuiSvgIcon-root': { color: 'white' },
                                                '&.Mui-disabled .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7) !important' }
                                            }}
                                            MenuProps={{
                                                sx: {
                                                    zIndex: 9999,
                                                },
                                                anchorOrigin: {
                                                    horizontal: 'left',
                                                    vertical: 'bottom'

                                                },
                                                // transformOrigin: {
                                                //     horizontal: 'right',
                                                //     vertical: 'bottom'

                                                // },
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: 'rgba(40, 40, 40, 0.95)',
                                                        '& .MuiMenuItem-root': {
                                                            color: 'white',
                                                            minHeight: '10px',
                                                            fontSize: { xs: '0.65rem', md: '0.8rem' },
                                                            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            {['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6']
                                                .map(s => (
                                                    <MenuItem key={s} value={s}>{s}</MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        {paperWidth}мм x {paperHeight}мм
                                    </Typography>
                                </Box>

                                {/* Orientation */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Typography sx={{ fontSize: '12px', minWidth: '80px' }}>
                                        Ориентация:
                                    </Typography>
                                    <FormControl sx={{
                                        minWidth: '120px',
                                        '& .Mui-disabled': {
                                            color: 'rgba(255, 255, 255, 0.7) !important'
                                        },
                                        '& .MuiSelect-select.Mui-disabled': {
                                            color: 'rgba(255, 255, 255, 0.7) !important',
                                            WebkitTextFillColor: 'rgba(255, 255, 255, 0.7) !important'
                                        }
                                    }}>
                                        <Select
                                            value={params.orientation}
                                            disabled={isPrinting}
                                            onChange={(e) => {
                                                setParams(p => { return { ...p, orientation: e.target.value } })
                                            }}
                                            slotProps={{

                                                input: {
                                                    sx: {
                                                        '&.Mui-disabled': {
                                                            color: 'rgba(255, 255, 255, 0.7) !important',
                                                            WebkitTextFillColor: 'rgba(255, 255, 255, 0.7) !important'
                                                        }
                                                    }
                                                }
                                            }}
                                            sx={{
                                                height: '32px',
                                                fontSize: { xs: '0.65rem', md: '0.8rem' },
                                                color: 'white',
                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.3)' },
                                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                                                '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                                                '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.7) !important' },
                                                '&.Mui-disabled .MuiSelect-select': { color: 'rgba(255, 255, 255, 0.7)' },
                                                '& .MuiSvgIcon-root': { color: 'white' },
                                                '&.Mui-disabled .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.7) !important' }
                                            }}
                                            MenuProps={{
                                                sx: {
                                                    zIndex: 9999,
                                                },
                                                PaperProps: {
                                                    sx: {
                                                        backgroundColor: 'rgba(40, 40, 40, 0.95)',
                                                        '& .MuiMenuItem-root': {
                                                            color: 'white',
                                                            minHeight: '10px',
                                                            fontSize: { xs: '0.65rem', md: '0.8rem' },
                                                            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem value="portrait">Portrait</MenuItem>
                                            <MenuItem value="landscape">Landscape</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>

                                {/* Switches */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={params.accounting}
                                                    onChange={e => { setParams(p => { return { ...p, accounting: e.target.checked } }) }}
                                                    sx={{
                                                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' },
                                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' },
                                                        '& .MuiSwitch-track': { backgroundColor: 'rgba(255, 255, 255, 0.3)' }
                                                    }}
                                                />
                                            }
                                            label={<Typography sx={{ fontSize: '12px' }}>Предписания</Typography>}
                                            sx={{ margin: 0 }}
                                        />
                                        {params.accounting && (
                                            <FormControl>
                                                <RadioGroup
                                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                                    name="controlled-radio-buttons-group"
                                                    value={params.accountingFilter}
                                                    onChange={e => setParams(p => { return { ...p, accountingFilter: e.target.value } })}
                                                >
                                                    <FormControlLabel
                                                        value="pillars"
                                                        label="По опорам"
                                                        sx={{
                                                            '& .MuiTypography-root': {
                                                                fontSize: '11px'
                                                            }
                                                        }}
                                                        control={<Radio sx={{
                                                            padding: '1px 10px',
                                                            color: '#4caf50',
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 20,
                                                            },
                                                            '&.Mui-checked': {
                                                                color: '#4caf50',
                                                            },
                                                        }} />} />
                                                    <FormControlLabel
                                                        value="checklist"
                                                        label="По кодам"
                                                        sx={{
                                                            '& .MuiTypography-root': {
                                                                fontSize: '11px'
                                                            }
                                                        }}
                                                        control={
                                                            <Radio sx={{
                                                                padding: '1px 10px',
                                                                color: '#4caf50',
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: 20,
                                                                },
                                                                '&.Mui-checked': {
                                                                    color: '#4caf50',
                                                                },
                                                            }} />
                                                        } />

                                                </RadioGroup>
                                            </FormControl>
                                        )}
                                    </Box>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={params.statement}
                                                onChange={e => {
                                                    setParams(p => { return { ...p, statement: e.target.checked, measure: e.target.checked } })
                                                }}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' },
                                                    '& .MuiSwitch-track': { backgroundColor: 'rgba(255, 255, 255, 0.3)' }
                                                }}
                                            />
                                        }
                                        label={<Typography sx={{ fontSize: '12px' }}>Поопорная ведомость</Typography>}
                                        sx={{ margin: 0 }}
                                    />
                                </Box>

                                {/* Buttons */}
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                                    <Button
                                        variant="contained"
                                        onClick={(e) => {
                                            revert()
                                            // setIsPrinting(false)
                                            // setIsDrawing(false)
                                            // setPolygon(null)
                                            // map.fire('signal:drawing', { source: 'print', state: false })
                                            // map.removeLayer(polygonRef.current)
                                            // polygonRef.current = null
                                            // drawingRef.current.disable()
                                        }}
                                        disabled={!isDrawing}
                                        sx={{
                                            fontSize: '12px',
                                            backgroundColor: '#f44336',
                                            color: 'white',
                                            minWidth: '50px',
                                            height: '28px',
                                            '&:hover': { backgroundColor: '#d32f2f' },
                                            '&:disabled': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                color: 'rgba(255, 255, 255, 0.7)'
                                            }
                                        }}
                                    >
                                        Отмена
                                    </Button>
                                    <Typography sx={{ fontSize: '12px', flexGrow: 1, textAlign: 'center' }}>
                                        Страниц: {grid.tiles.length || '—'}
                                    </Typography>
                                    {!isPrinting && (
                                        <Button
                                            variant="contained"
                                            onClick={(e) => {
                                                setIsPrinting(!isPrinting)
                                            }}
                                            disabled={!isCalculated}
                                            sx={{
                                                fontSize: '12px',
                                                backgroundColor: '#4caf50',
                                                color: 'white',
                                                minWidth: '50px',
                                                height: '28px',
                                                '&:hover': { backgroundColor: '#388e3c' },
                                                '&:disabled': {
                                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                    color: 'rgba(255, 255, 255, 0.7)'
                                                }
                                            }}
                                        >
                                            Печать
                                        </Button>
                                    )}
                                </Box>
                            </Box>

                            {/* Error Message */}
                            {isError && (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                                    padding: '5px 10px',
                                    color: isError.color,
                                    fontWeight: 'bold'
                                }}>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                        {isError.text}
                                    </Typography>
                                </Box>
                            )}
                        </Paper >
                        {
                            // isPrinting ? <div style={{ position: 'absolute', zIndex: 10000, pointerEvents: 'auto', backgroundColor: 'black', opacity: 0, top: 0, width: (paperWidth * MM_TO_INCH) * params.dpi, height: (paperHeight * MM_TO_INCH) * params.dpi }}>
                            isPrinting ? <div style={{ position: 'absolute', zIndex: 10000, pointerEvents: 'auto', backgroundColor: 'black', opacity: 0, top: 0, width: '100vw', height: '100vh' }}>
                            </div > : null
                        }
                    </>
                    , document.body)
            }
            {
                isCalculated ?
                    <FeatureGroup>
                        {grid.tiles.map((tile, index) => (
                            <Rectangle
                                key={index}
                                bounds={tile.bounds}
                                pathOptions={{
                                    // color: '#3388ff',
                                    color: 'black',
                                    weight: 2,
                                    fillOpacity: 0.1,
                                }}
                                data={'rex'}

                                pane='printingGridPane'





                            >


                                <Marker
                                    position={getTileCenterForText(tile)}
                                    icon={new L.DivIcon({
                                        html: `<span style='
                                            font-weight: bold; 
                                            font-size: ${30 + (4 - parseInt(params.paperSize.charAt(1))) * 8}px; 
                                            text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;'
                                        >#${index + 1}</span>`,
                                        className: `icon`, // чтобы убрать стандартные стили
                                        iconSize: [34 + (4 - parseInt(params.paperSize.charAt(1))) * 8, 34 + (4 - parseInt(params.paperSize.charAt(1))) * 8], // Размер иконки

                                    })}
                                    key={`${index}_marker`}
                                    data={'rex'}
                                    pane='printingGridPane'

                                >
                                </Marker>

                            </Rectangle>
                        ))}

                    </FeatureGroup>
                    : null
            }

        </>


    )

    // Отрисовка сетки
    // return (
    //     <>
    //         {createPortal(
    //             <>
    //                 {
    //                     bounds ?
    //                         <div className='print-controls' style={{
    //                             position: 'absolute',
    //                             zIndex: isPrinting ? 10001 : 1700,
    //                             fontSize: '12px',
    //                             color: 'white',
    //                             backgroundColor: 'black',
    //                             opacity: 0.8,
    //                             boxShadow: '0px 2px 6px grey',
    //                             borderRadius: '5px',
    //                             pointerEvents: 'auto',
    //                             border: '2px solid rgba(0, 0, 0, 0.2)',
    //                             bottom: '200px',
    //                             borderSpacing: '5px'

    //                         }}>

    //                             <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderBottom: '1px solid black', borderColor: 'white', padding: '3px' }}>
    //                                 <span>Настройки печати</span>
    //                                 {
    //                                     !isPrinting && <svg style={{ position: 'absolute', right: 0, top: 0 }} width={18} height={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
    //                                         onClick={() => {
    //                                             setBounds(null)
    //                                             setGrid({ width: 0, height: 0, tiles: [], dpi: null })
    //                                             map.eachLayer(l => {
    //                                                 if (l.options.data === 'rex' || l.options.data === 'rexd') map.removeLayer(l)
    //                                             })
    //                                             setHidden(true)
    //                                             const el = [...document.getElementsByClassName('leaflet-control leaflet-draw')]
    //                                             el.map(e => {
    //                                                 e.style.display = ''
    //                                             })
    //                                         }}
    //                                     >
    //                                         <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    //                                             fill="white"
    //                                         />
    //                                     </svg>
    //                                 }

    //                                 {/* <div>×</div> */}
    //                             </div>
    //                             <form className='print-control-from' style={{ padding: '3px' }}>
    //                                 <p className='print-control-p'>
    //                                     <label className='print-control-label'>Масштаб 1:</label>
    //                                     <input className='print-control-input' type="number" value={params.scale} disabled={isPrinting} onChange={(e) => {
    //                                         try {
    //                                             const v = Number(e.target.value)
    //                                             if (v > 0) {
    //                                                 setParams(p => { return { ...p, scale: v } })
    //                                             }
    //                                         } catch (err) {
    //                                         }
    //                                     }}
    //                                         min={1}
    //                                         step={100}
    //                                         style={{ width: '100px' }} />

    //                                     {/* <label className='print-control-label' style={{
    //                                     color: `hsl(${Math.min(Math.floor((140 - 0) * (grid.dpi - 0) / (300 - 0)), 140)}, 100%, 50%)`
    //                                 }}>({grid.dpi ? Math.round(grid.dpi) : '0'} DPI)</label> */}
    //                                 </p>
    //                                 <p className='print-control-p'>
    //                                     <label className='print-control-label'>DPI:</label>
    //                                     <input className='print-control-input' type="number" value={params.dpi} disabled={isPrinting} onChange={(e) => {
    //                                         try {
    //                                             const v = Number(e.target.value)
    //                                             if (v > 0) {
    //                                                 setParams(p => { return { ...p, dpi: v } })
    //                                             }
    //                                         } catch (err) {
    //                                         }
    //                                     }}
    //                                         min={10}
    //                                         max={500}
    //                                         step={10}
    //                                         style={{ width: '100px' }} />
    //                                     <label className='print-control-label' style={{
    //                                         color: `hsl(${Math.min(Math.floor((140 - 0) * (grid.zoom - 0) / (18 - 0)), 140)}, 100%, 50%)`
    //                                     }}>Зум: {grid.zoom ? grid.zoom : '0'}</label>
    //                                 </p>
    //                                 <p className='print-control-p'>
    //                                     <label className='print-control-label'>Формат:</label>
    //                                     <select className='print-control-select' value={params.paperSize} disabled={isPrinting} onChange={(e) => {

    //                                         setParams(p => { return { ...p, paperSize: e.target.value } })
    //                                     }}>
    //                                         {['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6']
    //                                             .map(s => (<option key={s} defaultValue={s === params.paperSize}>{s}</option>))}
    //                                     </select>
    //                                     <label className='print-control-label'>{paperWidth}мм x {paperHeight}мм</label>
    //                                 </p>
    //                                 <p className='print-control-p'>
    //                                     <label className='print-control-label'>Ориентация:</label>

    //                                     <select className='print-control-select' value={params.orientation} disabled={isPrinting} onChange={(e) => {

    //                                         setParams(p => { return { ...p, orientation: e.target.value } })
    //                                     }}>
    //                                         {['portrait', 'landscape']
    //                                             .map(s => (<option key={s} defaultValue={s === params.orientation}>{s}</option>))}
    //                                     </select>

    //                                 </p>
    //                                 <div className='print-control-p'>
    //                                     <label className='print-control-label'>Предписания:</label>

    //                                     <Form.Check // prettier-ignore
    //                                         type="switch"
    //                                         id="custom-switch"
    //                                         // checked={state.accounting}
    //                                         defaultChecked={params.accounting}
    //                                         className="m-0"
    //                                         // disabled={!state.text}

    //                                         onChange={e => { setParams(p => { return { ...p, accounting: e.target.checked } }) }}
    //                                     />

    //                                 </div>
    //                                 <div className='print-control-p'>
    //                                     <label className='print-control-label' style={{ whiteSpace: 'wrap' }}>Поопорная ведомость:</label>

    //                                     <Form.Check // prettier-ignore
    //                                         type="switch"
    //                                         id="custom-switch"
    //                                         // checked={state.accounting}
    //                                         defaultChecked={params.statement}
    //                                         className="m-0"

    //                                         onChange={e => {
    //                                             setParams(p => { return { ...p, statement: e.target.checked, measure: e.target.checked } })

    //                                         }}
    //                                     />

    //                                 </div>
    //                                 <p className='print-control-p'>
    //                                     <input className='print-control-button'
    //                                         type='button'
    //                                         onClick={(e) => {
    //                                             setIsPrinting(!isPrinting)
    //                                             // printMap()
    //                                             // exportPillars04()
    //                                         }}
    //                                         disabled={!isCalculated}
    //                                         style={{ fontWeight: 'bold', backgroundColor: !isPrinting ? 'limegreen' : 'red', borderRadius: '3px', border: 'none' }}
    //                                         value={!isPrinting ? 'Печать' : 'Отмена'}
    //                                     />
    //                                     <label className='print-control-label'>Страниц: {grid.tiles.length || '—'}</label>
    //                                 </p>




    //                             </form>
    //                             {
    //                                 isError ?
    //                                     <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: '1px solid black', padding: '3px', color: `${isError.color}`, fontWeight: 'bold' }}>
    //                                         {isError.text}
    //                                         {/* <lable className='print-control-label'></lable> */}
    //                                     </div>
    //                                     : null
    //                             }


    //                         </div>



    //                         : null
    //                 }
    //                 {
    //                     // isPrinting ? <div style={{ position: 'absolute', zIndex: 10000, pointerEvents: 'auto', backgroundColor: 'black', opacity: 0, top: 0, width: (paperWidth * MM_TO_INCH) * params.dpi, height: (paperHeight * MM_TO_INCH) * params.dpi }}>
    //                     isPrinting ? <div style={{ position: 'absolute', zIndex: 10000, pointerEvents: 'auto', backgroundColor: 'black', opacity: 0, top: 0, width: '100vw', height: '100vh' }}>
    //                     </div> : null
    //                 }
    //             </>
    //             , document.body)
    //         }
    //         {
    //             hidden ?
    //                 createPortal(
    //                     <div className='leaflet-control leaflet-draw' style={{ order: 1 }}>
    //                         <div className='leaflet-draw-open' ref={drawCloseRef} style={{
    //                             height: '30px',
    //                             width: '30px',
    //                             borderRadius: '3px',
    //                             backgroundColor: 'rgb(0, 0, 0)',
    //                             opacity: '0.7',
    //                             pointerEvents: 'auto',
    //                             cursor: 'pointer'
    //                         }}
    //                             onClick={(e) => {
    //                                 e.stopPropagation();
    //                                 setHidden(false)
    //                                 const el = [...document.getElementsByClassName('leaflet-control leaflet-draw')]
    //                                 el.map(e => {
    //                                     e.style.display = 'none'
    //                                 })
    //                             }}

    //                         >
    //                             <div className='leaflet-draw-close-icon' style={{
    //                                 position: 'absolute',
    //                                 top: '50%',
    //                                 left: '50%',
    //                                 transform: 'translate(-50%, -50%)'
    //                             }}>
    //                                 <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    //                                     <path d="M128 0C92.7 0 64 28.7 64 64l0 96 64 0 0-96 226.7 0L384 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0L128 0zM384 352l0 32 0 64-256 0 0-64 0-16 0-16 256 0zm64 32l32 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    //                                         fill='white' />
    //                                 </svg>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     , document.getElementsByClassName('leaflet-bottom leaflet-left')[0])

    //                 :
    //                 <FeatureGroup pane='printingBoundsPane'>

    //                     {
    //                         createPortal(
    //                             <div className='leaflet-control leaflet-draw' style={{ order: 10 }}>
    //                                 <div className='leaflet-print-close' ref={drawCloseRef} style={{
    //                                     height: '30px',
    //                                     width: '30px',
    //                                     borderRadius: '3px',
    //                                     backgroundColor: 'rgb(0, 0, 0)',
    //                                     opacity: '0.7',
    //                                     pointerEvents: 'auto',
    //                                     cursor: 'pointer'
    //                                 }}
    //                                     onClick={(e) => {
    //                                         e.stopPropagation();
    //                                         setBounds(null)
    //                                         setGrid({ width: 0, height: 0, tiles: [], dpi: null })
    //                                         map.eachLayer(l => {
    //                                             if (l.options.data === 'rex' || l.options.data === 'rexd') map.removeLayer(l)
    //                                         })
    //                                         setHidden(true)
    //                                         const el = [...document.getElementsByClassName('leaflet-control leaflet-draw')]
    //                                         el.map(e => {
    //                                             e.style.display = ''
    //                                         })
    //                                     }}

    //                                 >
    //                                     <div className='leaflet-print-close-icon' style={{
    //                                         position: 'absolute',
    //                                         top: '50%',
    //                                         left: '50%',
    //                                         transform: 'translate(-50%, -50%)'
    //                                     }}>
    //                                         <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    //                                             <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    //                                                 fill="white"
    //                                             />
    //                                         </svg>
    //                                     </div>


    //                                 </div>
    //                             </div>, document.getElementsByClassName('leaflet-bottom leaflet-left')[0])
    //                     }

    //                     <EditControl key={'draw'}
    //                         position='bottomleft'

    //                         draw={{
    //                             polyline: false, // Включаем рисование линий
    //                             polygon: true,
    //                             circle: false,
    //                             rectangle: true,
    //                             marker: false,
    //                             circlemarker: false
    //                         }}
    //                         edit={{
    //                             featureGroup: bounds,
    //                             remove: false,
    //                             edit: bounds ? true : false

    //                         }}


    //                         onCreated={(e) => {
    //                             map.eachLayer(l => {
    //                                 if (l.options.data === 'rexd') map.removeLayer(l)
    //                             })

    //                             const { layer } = e;
    //                             layer.options.data = 'rexd'
    //                             setBounds(layer.getBounds())

    //                         }}
    //                         onDeleted={() => {
    //                             setBounds(null)
    //                             setGrid({ width: 0, height: 0, tiles: [], dpi: null })

    //                         }}

    //                         // onEditStop={(e) => {
    //                         //     calculateGrid()
    //                         // }}
    //                         onEdited={(e) => {
    //                             map.eachLayer(l => {
    //                                 if (l.options.data === 'rexd') setBounds(l.getBounds())
    //                             })
    //                             // const { layer } = e;
    //                             // setBounds(layer.getBounds())
    //                         }}
    //                     />
    //                 </FeatureGroup >
    //         }




    //         {
    //             isCalculated ?
    //                 <FeatureGroup>
    //                     {grid.tiles.map((tile, index) => (
    //                         <Rectangle
    //                             key={index}
    //                             bounds={tile.bounds}
    //                             pathOptions={{
    //                                 // color: '#3388ff',
    //                                 color: 'black',
    //                                 weight: 2,
    //                                 fillOpacity: 0.1,
    //                             }}
    //                             data={'rex'}

    //                             pane='printingGridPane'





    //                         >


    //                             <Marker
    //                                 position={getTileCenterForText(tile)}
    //                                 icon={new L.DivIcon({
    //                                     html: `<span style='
    //                                         font-weight: bold; 
    //                                         font-size: ${30 + (4 - parseInt(params.paperSize.charAt(1))) * 8}px; 
    //                                         text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;'
    //                                     >#${index + 1}</span>`,
    //                                     className: `icon`, // чтобы убрать стандартные стили
    //                                     iconSize: [34 + (4 - parseInt(params.paperSize.charAt(1))) * 8, 34 + (4 - parseInt(params.paperSize.charAt(1))) * 8], // Размер иконки

    //                                 })}
    //                                 key={`${index}_marker`}
    //                                 data={'rex'}
    //                                 pane='printingGridPane'

    //                             >
    //                             </Marker>

    //                         </Rectangle>
    //                     ))}

    //                 </FeatureGroup>
    //                 : null
    //         }
    //     </>)

};

export default PrintControl;